import React, { useContext } from 'react';

const IsPublicViewContext = React.createContext(false);

interface PublicViewProviderProps {
  children: React.ReactNode;
  publicView: boolean;
}

export const IsPublicViewProvider = ({
  children,
  publicView,
}: PublicViewProviderProps) => (
  <IsPublicViewContext.Provider value={publicView}>
    {children}
  </IsPublicViewContext.Provider>
);

const useIsPublicView = () => {
  return useContext(IsPublicViewContext);
};

export default useIsPublicView;
